import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getAsset,
  saveToJSONFile,
  saveNewPasswords,
  changeTab
} from "../actions";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import CustomTextField from "../components/common/CustomTextField";
import Tariff from "../components/siteInformation/tariff";
import { getConfig } from "../reducers/config";
import { getLastPmax } from '../reducers/chart_data_reducer';
import { get, capitalize, isArray } from "lodash";

// Material UI
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import DateIcon from "@material-ui/icons/DateRange";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from "@material-ui/core/Avatar";

const styles = theme => ({
  card: {
    minWidth: 275,
    maxWidth: 800,
    margin: "0 auto"
  },
  input: {
    margin: theme.spacing(1)
  },
  flex: {
    flex: 1
  },
  toolbar: {
    borderBottom: "1px solid #e5e5e5"
  },
  root: {
    minWidth: 300,
    maxWidth: 800,
    margin: "0 auto"
  },
  actionContainer: {
    textAlign: "right",
    "& button": {
      margin: 10
    }
  },
  disabledTab: {
    display: 'none'
  }
});

class SiteInformation extends Component {
  constructor(props) {
    super(props);

    this.form = React.createRef();
    this.currentPassword = React.createRef();
    this.passwordOperator = React.createRef();
    this.passwordOperator2 = React.createRef();
    this.passwordCustomer = React.createRef();
    this.passwordCustomer2 = React.createRef();

    this.state = {
      value: 0,
      currentPassword: '',
      passwordCustomer: '',
      passwordCustomer2: '',
      passwordOperator: '',
      passwordOperator2: '',
      siteName: '',
      isAtypical: null,
      pMax: 0,
      file: {
        asset: {
          description: '',
          timezone: '',
          bess_capacity_kwh: '',
          bess_supplier: '',
          bess_technical_contact: {
            name: '',
            email: '',
            tel: ''
          },
          bess_commercial_contact: {
            email: '',
            tel: '',
            name: ''
          },
          customer_commercial_contact: {
            email: '',
            tel: '',
            name: ''
          },
          customer_technical_contact: {
            email: '',
            tel: '',
            name: ''
          },
          peak_shaving_type: '',
          peak_shaving_generic: {
            p_ref_kw: '',
            p_max_kw: ''
          },
          peak_shaving_atypical: {
            deviation: '',
            p_max_on_peak_kw: ''
          }
        },
        permissions: {
          operator: {
            username: 'operator1',
            password: '123',
            isOperator: true
          },
          customer: {
            username: 'customer1',
            password: '123',
            isOperator: false
          }
        }
      }
    };
  }

  async componentDidMount() {
    await this.props.getAsset();

    const {
      peak_shaving_type,
      description,
      peak_shaving_generic,
      peak_shaving_atypical,
      bess_capacity_kwh,
      bess_supplier,
      bess_technical_contact,
      bess_commercial_contact,
      customer_commercial_contact,
      customer_technical_contact
    } = this.props.asset;

    this.setState(state => ({
      ...state,
      file: {
        ...state.file,
        asset: {
          description,
          timezone: 'Europe/Berlin',
          bess_capacity_kwh,
          bess_supplier,
          bess_technical_contact,
          bess_commercial_contact,
          customer_commercial_contact,
          customer_technical_contact,
          peak_shaving_type,
          peak_shaving_generic,
          peak_shaving_atypical
        }
      }
    }));

    const { operator, customer } = this.props.permissions;
    this.setState(state => ({
      ...state,
      file: {
        ...state.file,
        permissions: {
          operator,
          customer
        }
      }
    }));

    ValidatorForm.addValidationRule('isCustomerPasswordMatch', value => {
      if (value !== this.state.passwordCustomer) {
        this.setState({ saveCustomPwdEnabled: false });
        return false;
      }
      this.setState({ saveCustomPwdEnabled: true });
      return true;
    });

    ValidatorForm.addValidationRule('isOperatorPasswordMatch', value => {
      if (value !== this.state.passwordOperator) {
        this.setState({ saveEnabled: false });
        return false;
      }
      this.setState({ saveEnabled: true });
      return true;
    });

    this.updateSiteDetails();
  }

  updateSiteDetails = () => {
    const { siteName, isAtypical, pMax } = this.props;
    this.setState({
      ...this.state,
      siteName,
      isAtypical,
      pMax
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { siteName: prevSiteName, isAtypical: prevIsAtypical, pMax: prevPMax } = prevProps;
    const { siteName, isAtypical, pMax } = this.props;
    const newState = {};

    if (prevSiteName !== siteName) {
      newState.siteName = siteName;
    }

    if (prevIsAtypical !== isAtypical) {
      newState.isAtypical = isAtypical;
    }

    if (prevPMax !== pMax) {
      newState.pMax = pMax;
    }

    if (Object.keys(newState).length) {
      this.setState(state => ({
        ...state,
        ...newState
      }));
    }

    if (this.state.value !== prevState.value) {
      if (this.state.value === 4) {
        this.setState({ saveEnabled: false, saveCustomPwdEnabled: false });
      }
    }
    if (this.props.permissions !== prevProps.permissions) {
      const { operator, customer } = this.props.permissions;
      this.setState(state => ({
        ...state,
        file: {
          ...state.file,
          permissions: {
            operator,
            customer
          }
        }
      }));
    }
  };

  getTabId = () => parseInt(get(this.props.match, 'params.tabId', null), 10);

  handleSave = () => {
    const {
      currentPassword,
      passwordOperator,
      passwordCustomer
    } = this.state;

    const value = this.getTabId();

    if (value === 4) {
      this.props.saveNewPasswords(
        currentPassword,
        passwordOperator,
        passwordCustomer
      );
      this.setState(
        {
          currentPassword: '',
          passwordOperator: '',
          passwordOperator2: '',
          passwordCustomer: '',
          passwordCustomer2: ''
        }
      );
    } else {
      this.props.saveToJSONFile(this.state.file.asset);
    }
  };

  renderSaveButton = classes => {
    return (
      <React.Fragment>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={!this.state.saveEnabled}
        >
          Save
        </Button>
      </React.Fragment>
    );
  };

  renderSaveCustomPwdButton = classes => {
    return (
      <React.Fragment>
        {/* <Button
            variant="contained"
            color="default"
            className={classes.button}
          >
            Cancel
          </Button> */}
        <Button
          type="submit"
          //onClick={this.handleSave}
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={!this.state.saveCustomPwdEnabled}
        >
          Save
        </Button>
      </React.Fragment>
    );
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleTextChange = (name, value) => {
    //const { name, value } = event.target;
    this.setState((state) => ({
      file: {
        ...state.file,
        asset: {
          ...state.file.asset,
          [name]: value
        }
      }
    }));
  };

  handleNestedTextChange = (name, value, type) => {
    const [parent, child] = name.split(".");
    this.setState((state) => ({
      file: {
        ...state.file,
        asset: {
          ...state.file.asset,
          [parent]: {
            ...state.file.asset[parent],
            [child]: type === 'number' ? parseInt(value, 10) : value
          }
        }
      }
    }));
  };

  handleChangeIndex = (event, index) => this.props.changeTab('site', index);

  getSeason = season => {
    const { classes, tariff } = this.props;

    const twoDigit = value => value < 10 ? `0${value}` : value;
    const seasonData = get(tariff, `[${season}].values`);
    const seasonMonths = get(tariff, `[${season}].months`);

    return (seasonMonths && <Grid item xs={6} key={season}>
      <h3>{capitalize(season)} peak periods</h3>
      <p>{`${capitalize(seasonMonths[0])} - ${capitalize(seasonMonths[1])}`}</p>
      <List className={classes.root}>
        {
          seasonData ?
            seasonData.map(({ start, end }, index) => <ListItem key={`${season}-${index}`}>
              <ListItemAvatar>
                <Avatar>
                  <DateIcon/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={`${twoDigit(start.h)}:${twoDigit(start.m)} - ${twoDigit(end.h)}:${twoDigit(end.m)}`}
              />
            </ListItem>) :
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <DateIcon/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="No peak time"/>
            </ListItem>
        }
      </List>
    </Grid>) || null;
  };

  formatDate = date => isArray(date) ? date.join(' - ') : date;

  getDaysOff = () => {
    const { tariff: { daysOff }, classes } = this.props;
    return daysOff && daysOff.length ? (
      <Grid item xs={12}>
        <h3>Holidays and excluded days off</h3>

        <List className={classes.root} style={{ columns: 2 }}>
          {daysOff.map(({ date, name }, index) => <ListItem key={`daysOff-${index}`}>
            <ListItemText
              primary={this.formatDate(date)}
              secondary={name}
            />
          </ListItem>)}
        </List>
      </Grid>
    ) : null;
  };

  render() {
    const { siteName, isAtypical } = this.state;
    const { classes } = this.props;
    const value = this.getTabId();
    const {
      description,
      bess_capacity_kwh,
      bess_supplier,
      bess_technical_contact,
      bess_commercial_contact,
      customer_commercial_contact,
      customer_technical_contact
    } = this.state.file.asset;

    const siteType = isAtypical ? "Atypical" : "Generic";
    const { isOperator } = this.props;
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={this.handleChangeIndex}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Site" value={0}/>
            <Tab label="Customer" value={1}/>
            <Tab label="Battery" value={2}/>
            <Tab label="Peak period" value={3} disabled={!isAtypical}
                 className={!isAtypical ? classes.disabledTab : null}/>
            <Tab id="admin-tab" label="Admin" value={4}/>
          </Tabs>
        </AppBar>

        {value === 0 && (
          <div style={{ padding: 8 * 3 }}>
            <ValidatorForm
              ref={this.form}
              onSubmit={this.handleSave}
              onError={errors => console.log("error on form submit", errors)}
              debounceTime={300}
            >
              <Paper className={classes.root}>
                <Toolbar className={classes.toolbar}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    Site Details
                  </Typography>
                  {isOperator && !isAtypical && (
                    <IconButton
                      disabled
                      size="small"
                      aria-label="Save Assumptions"
                    >
                      <Edit/>
                    </IconButton>
                  )}
                </Toolbar>
                <div style={{ width: "100%", padding: 8 * 3 }}>
                  {/* <FormControl fullWidth>
  <InputLabel htmlFor="select-type">
  Select Site Type
  </InputLabel>
  <Select value={siteType} input={<Input id="select-type" />}>
  <MenuItem key="Generic" value="Generic">
  Generic
  </MenuItem>
  <MenuItem key="ATypical" value="ATypical">
  ATypical
  </MenuItem>
  </Select>
  </FormControl> */}
                  <CustomTextField
                    value={siteType}
                    onChange={this.handleTextChange}
                    readOnly={true}
                    label="Site Type"
                    name="site_type"
                  />
                  <CustomTextField
                    value={siteName}
                    readOnly={true}
                    label="Site Details"
                    name="description"
                  />
                  {/*{!isAtypical && (
  <React.Fragment>
  <CustomTextField
  value={pMax}
  readOnly={true}
  label="Power Max"
  name="peak_shaving_generic.p_max_kw"
  type="number"
  />
  <CustomTextField
  value={peak_shaving_generic.p_ref_kw}
  onChange={this.handleNestedTextChange}
  readOnly={!isOperator}
  label="Power Reference"
  type="number"
  name="peak_shaving_generic.p_ref_kw"
  />
  </React.Fragment>
  )}*/}
                  {/*{isAtypical && (
  <React.Fragment>
  <CustomTextField
  value={peak_shaving_atypical.p_max_on_peak_kw}
  onChange={this.handleNestedTextChange}
  readOnly={!isOperator}
  label="Power Max On Peak (kW)"
  name="peak_shaving_atypical.p_max_on_peak_kw"
  type="number"
  />
  <CustomTextField
  value={peak_shaving_atypical.deviation}
  onChange={this.handleNestedTextChange}
  readOnly={!isOperator}
  label="Deviation (%)"
  name="peak_shaving_atypical.deviation"
  type="number"
  />
  </React.Fragment>
  )}*/}
                </div>
                {isOperator && !isAtypical ? (
                  <div className={classes.actionContainer}>
                    {this.renderSaveButton(classes)}
                  </div>
                ) : null}
              </Paper>
            </ValidatorForm>
          </div>
        )}
        {value === 1 && (
          <div style={{ padding: 8 * 3 }}>
            <ValidatorForm
              ref={this.form}
              onSubmit={this.handleSave}
              onError={errors => console.log("error on form submit", errors)}
              debounceTime={300}
            >
              <Paper className={classes.root}>
                <Toolbar className={classes.toolbar}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    Customer Details
                  </Typography>
                  {isOperator ? (
                    <IconButton
                      disabled
                      size="small"
                      aria-label="Save Assumptions"
                    >
                      <Edit/>
                    </IconButton>
                  ) : null}
                </Toolbar>
                <div style={{ width: "100%", padding: 8 * 3 }}>
                  <CustomTextField
                    value={description}
                    onChange={this.handleTextChange}
                    readOnly={!isOperator}
                    label="Customer Name"
                    name="description"
                  />
                  <h4>Commercial Contact</h4>
                  <CustomTextField
                    value={customer_commercial_contact.name}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Contact Name"
                    name="customer_commercial_contact.name"
                  />
                  <CustomTextField
                    value={customer_commercial_contact.email}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Contact Email"
                    name="customer_commercial_contact.email"
                  />
                  <CustomTextField
                    value={customer_commercial_contact.tel}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Phone"
                    name="customer_commercial_contact.tel"
                  />
                  <h4>Technical Contact</h4>
                  <CustomTextField
                    value={customer_technical_contact.name}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Name"
                    name="customer_technical_contact.name"
                  />
                  <CustomTextField
                    value={customer_technical_contact.email}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Email"
                    name="customer_technical_contact.email"
                  />
                  <CustomTextField
                    value={customer_technical_contact.tel}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Phone"
                    name="customer_technical_contact.tel"
                  />
                </div>
                {isOperator ? (
                  <div className={classes.actionContainer}>
                    {this.renderSaveButton(classes)}
                  </div>
                ) : null}
              </Paper>
            </ValidatorForm>
          </div>
        )}
        {value === 2 && (
          <div style={{ padding: 8 * 3 }}>
            <ValidatorForm
              ref={this.form}
              onSubmit={this.handleSave}
              onError={errors => console.log("error on form submit", errors)}
              debounceTime={300}
            >
              <Paper className={classes.root}>
                <Toolbar className={classes.toolbar}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    Battery Details
                  </Typography>
                  {isOperator && (
                    <IconButton
                      disabled
                      size="small"
                      aria-label="Save Assumptions"
                    >
                      <Edit/>
                    </IconButton>
                  )}
                </Toolbar>
                <div style={{ width: "100%", padding: 8 * 3 }}>
                  <CustomTextField
                    value={bess_supplier}
                    onChange={this.handleTextChange}
                    readOnly={!isOperator}
                    label="Supplier Name"
                    name="bess_supplier"
                  />

                  <CustomTextField
                    value={bess_capacity_kwh}
                    onChange={this.handleTextChange}
                    readOnly={!isOperator}
                    label="Power Rating"
                    name="bess_capacity_kwh"
                  />

                  <CustomTextField
                    value={bess_capacity_kwh}
                    onChange={this.handleTextChange}
                    readOnly={!isOperator}
                    label="Installed Energy Capacity"
                    name="bess_capacity_kwh"
                  />

                  <h4>Commercial Contact</h4>
                  <CustomTextField
                    value={bess_commercial_contact.name}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Contact Name"
                    name="bess_commercial_contact.name"
                  />
                  <CustomTextField
                    value={bess_commercial_contact.email}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Contact Email"
                    name="bess_commercial_contact.email"
                  />
                  <CustomTextField
                    value={bess_commercial_contact.tel}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Phone"
                    name="bess_commercial_contact.tel"
                  />
                  <h4>Technical Contact</h4>
                  <CustomTextField
                    value={bess_technical_contact.name}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Name"
                    name="bess_technical_contact.name"
                  />

                  <CustomTextField
                    value={bess_technical_contact.email}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Email"
                    name="bess_technical_contact.email"
                  />
                  <CustomTextField
                    value={bess_technical_contact.tel}
                    onChange={this.handleNestedTextChange}
                    readOnly={!isOperator}
                    label="Phone"
                    name="bess_technical_contact.tel"
                  />
                </div>
                {isOperator ? (
                  <div className={classes.actionContainer}>
                    {this.renderSaveButton(classes)}
                  </div>
                ) : null}
              </Paper>
            </ValidatorForm>
          </div>
        )}

        {value === 3 && isAtypical && (
          <div style={{ padding: 8 * 3 }}>
            <Tariff>
              <Paper className={classes.root}>
                <Toolbar className={classes.toolbar}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    Grid on peak period
                  </Typography>
                  {/* {isOperator && (
  <IconButton disabled size="small" aria-label="Save Assumptions">
  <Edit />
  </IconButton>
  )} */}
                </Toolbar>
                <div style={{ width: "100%", padding: 8 * 3 }}>
                  <Grid container spacing={3}>
                    {this.getSeason('spring')}
                    {this.getSeason('summer')}
                    {this.getSeason('autumn')}
                    {this.getSeason('winter')}

                    <Grid item xs={12}>
                      <p>The time windows are specified as time, not as load profile timestamp (e.g. 11:45 - 13:00
                        corresponds to ¼-h-till-values 12:00 - 13:00)</p>
                    </Grid>

                    {this.getDaysOff()}
                  </Grid>
                </div>
                {/*<div className={classes.actionContainer}>
  {this.renderSaveButton(classes)}
  </div>*/}
              </Paper>
            </Tariff>
          </div>
        )}
        {value === 4 && (
          <div style={{ padding: 8 * 3 }}>
            <Paper className={classes.root}>
              <Toolbar className={classes.toolbar}>
                <Typography
                  color="inherit"
                  variant="h6"
                  className={classes.flex}
                >
                  Admin
                </Typography>
                <IconButton
                  disabled
                  size="small"
                  aria-label="Save Assumptions"
                >
                  <Edit/>
                </IconButton>
              </Toolbar>


              <ValidatorForm
                ref={this.form}
                onSubmit={this.handleSave}
                onError={errors => console.log("error on form submit", errors)}
                debounceTime={300}
              >
                <div
                  style={{
                    width: "100%",
                    padding: 8 * 3
                  }}
                >
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    {isOperator ? 'Current Operator Password' : 'Current Customer Password'}
                  </Typography>
                  {/* <FormControl margin="normal" required fullWidth> */}
                  <TextValidator
                    ref={this.currentPassword}
                    id="current-password"
                    label={isOperator ? 'Current Operator Password' : 'Current Customer Password'}
                    type="password"
                    onChange={this.handleChange}
                    name="currentPassword"
                    value={this.state.currentPassword}
                    validators={["required"]}
                    errorMessages={[
                      "this field is required"
                    ]}
                    fullWidth
                    margin="normal"
                  />
                  {/* </FormControl> */}
                </div>


                {(isOperator && (
                  <div style={{ width: "100%", padding: 8 * 3 }}>
                    <Typography
                      color="inherit"
                      variant="h6"
                      className={classes.flex}
                    >
                      New Operator Password
                    </Typography>
                    {/* <FormControl margin="normal" required fullWidth> */}
                    <TextValidator
                      ref={this.passwordOperator}
                      id="operator-password"
                      label="New Operator Password"
                      type="password"
                      onChange={this.handleChange}
                      name="passwordOperator"
                      value={this.state.passwordOperator}
                      //validators={["required"]}
                      //errorMessages={["this field is required"]}
                      fullWidth
                      margin="normal"
                    />
                    <TextValidator
                      ref={this.passwordOperator2}
                      id="operator-password2"
                      label="Confirm New Operator Password"
                      type="password"
                      onChange={this.handleChange}
                      name="passwordOperator2"
                      value={this.state.passwordOperator2}
                      validators={["isOperatorPasswordMatch"]}
                      errorMessages={["Operator passwords are not matching!"]}
                      fullWidth
                      margin="normal"
                    />
                    {/* </FormControl> */}
                    <div className={classes.actionContainer}>
                      {this.renderSaveButton(classes)}
                    </div>
                  </div>
                )) || null}

                <div style={{ padding: 8 * 3 }}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.flex}
                  >
                    New Customer Password
                  </Typography>
                  {/* <FormControl margin="normal" required fullWidth> */}
                  <TextValidator
                    ref={this.passwordCustomer}
                    id="customer-password"
                    type="password"
                    label="New Customer Password"
                    onChange={this.handleChange}
                    name="passwordCustomer"
                    value={this.state.passwordCustomer}
                    //validators={["required"]}
                    //errorMessages={["this field is required"]}
                    fullWidth
                    margin="normal"
                  />
                  <TextValidator
                    ref={this.passwordCustomer2}
                    id="customer-password2"
                    label="Confirm New Customer Password"
                    type="password"
                    onChange={this.handleChange}
                    name="passwordCustomer2"
                    value={this.state.passwordCustomer2}
                    validators={["isCustomerPasswordMatch"]}
                    errorMessages={["Customers passwords are not matching!"]}
                    fullWidth
                    margin="normal"
                  />
                  {/* </FormControl> */}
                  <div className={classes.actionContainer}>
                    {this.renderSaveCustomPwdButton(classes)}
                  </div>
                </div>
              </ValidatorForm>
            </Paper>
          </div>
        )}
      </div>
    );
  }
}

SiteInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    asset: state.asset,
    isOperator: state.auth.isOperator,
    seasons: state.tariff.seasons,
    tariff: state.tariff,
    permissions: state.permissions,
    isAtypical: get(getConfig(state), 'config.ATYPICAL'),
    siteName: get(getConfig(state), 'config.SITE_NAME'),
    pMax: getLastPmax(state)
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {
      getAsset,
      saveToJSONFile,
      saveNewPasswords,
      changeTab
    }
  )(SiteInformation)
);



// WEBPACK FOOTER //
// ./src/pages/SiteInformation.js